export function Landing({ onStart, onDocs }: { onStart: () => void; onDocs: () => void }) {
  return (
    <>
      <section className="hero">
        <h1>Платформа ботов<br />svoisozvon.</h1>
        <p className="lead">
          Создайте бота, получите токен — и начинайте. Один API для сообщений, чатов
          и вебхуков. Сделано для разработчиков, без лишних панелей.
        </p>
        <div className="cta">
          <button className="btn primary" onClick={onStart}>Создать ключ →</button>
          <button className="btn" onClick={onDocs}>Документация</button>
        </div>

        <div className="kbd">
{`$ curl https://api.podryvanov.ru/api/bot/sendMessage \\
    -H "Authorization: Bot $TOKEN" \\
    -d '{"chatId":"...","text":"Привет, мир"}'
`}<span className="c">{`# → { "ok": true }`}</span>
        </div>
      </section>

      <div className="features">
        <div className="f">
          <h3>Ключ — это бот</h3>
          <p>Задайте имя и описание — и сразу получите токен, который работает с API.</p>
        </div>
        <div className="f">
          <h3>Приём и отправка</h3>
          <p>Отправляйте сообщения, читайте чаты, подключите вебхук для входящих.</p>
        </div>
        <div className="f">
          <h3>Полный контроль</h3>
          <p>Отзовите ключ в любой момент — токен умирает сразу. Держите несколько сразу.</p>
        </div>
      </div>
    </>
  )
}
